import { DownloadLanguages } from '@websrc/App/Components/Download/DownloadLanguage'
import { Markdown } from '@websrc/App/Components/Markdown/Markdown'
import { useStaticText } from '@websrc/App/Hooks/useStaticText'
import { mapDownload } from '@websrc/DataMappers/mapDownload'
import clsx from 'clsx'
import { styles, typography } from 'leds'
import React, { FC } from 'react'

import { AccordionGroup, AccordionItem } from '../Accordion/AccordionGroup'

export type DownloadSpecsProps = {
  data: ReturnType<typeof mapDownload>
  device: ReturnType<typeof mapDownload>['items'][0]
  language: DownloadLanguages[0]
}

const Label = ({ text }: { text: string }) => (
  <span className={clsx(typography(), styles({ padding: 10 }))}>{text}</span>
)

export const DownloadSpecs: FC<DownloadSpecsProps> = ({ data, device, language }) => {
  const t = useStaticText()
  const isWebApp = language.__downloadType === 'webApp'
  const { webApp, appReleaseNotes } = data

  let accordionItems: AccordionItem[]

  if (isWebApp && webApp) {
    accordionItems = [
      {
        label: <Label text={t.downloads.software_requirements} />,
        content: (
          <>
            <Markdown markdown={webApp.requirements} />
            {device.requirements && <Markdown markdown={device.requirements} />}
          </>
        ),
        itemId: t.downloads.software_requirements,
      },
      {
        label: <Label text={t.downloads.web_app_instructions} />,
        content: <Markdown markdown={webApp.instructions} />,
        itemId: t.downloads.web_app_instructions,
      },
    ]
  } else {
    accordionItems = [
      {
        label: <Label text={t.downloads.software_requirements} />,
        content: device.requirements && <Markdown markdown={device.requirements} />,
        itemId: t.downloads.software_requirements,
      },
      {
        label: <Label text={t.downloads.app_release_notes} />,
        content: appReleaseNotes && <Markdown markdown={appReleaseNotes} />,
        itemId: t.downloads.app_release_notes,
      },
    ]
  }

  return (
    <div className={styles({ marginY: 40 })}>
      <AccordionGroup allowMultipleOpen={true} items={accordionItems} />
    </div>
  )
}
